export default __webpack_public_path__ + "24d4523b3c85c50a4e14b2b95024db40.svg";